import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
    firstGetDataIntervalAPI,
    manualGetDataIntervalAPI,
    manualGetOnlineViewerIntervalAPI,
    manualPostAPI
} from "../../../redux/actions/videoData.actions";
import { conditions } from "../../conditions/conditions";
import { ConditionName } from "../../../interfaces/enums";
import { RetryCountGeneralDataFetch, RetryTimeDelayGeneralDataFetch } from "../../environment";
import { shallowEqual } from "react-redux";

const useGetAggregat = () => {
    const dispatch = useAppDispatch();
    const { isLiveError } = useAppSelector(({ videoData: { params, isLiveError } }) => ({ params, isLiveError }), shallowEqual);
    const { loadedFragmentsCount } = useAppSelector(({ controller: { loadedFragmentsCount } }) => ({ loadedFragmentsCount }), shallowEqual);

    const getGeneralData = (intervalIds: any, intervalTime: any, setActiveApiRequest: any, setIntervalIds: any) => {
        const intervalIdTemp: any = intervalIds;
        const intervalId = setInterval(() => {
            setActiveApiRequest((prev: any) => !prev);
        }, intervalTime * 1000);
        intervalIdTemp.push(intervalId);
        setIntervalIds(intervalIdTemp);
    };

    /// Online_Viewer interval
    const [onlineViewerActiveApiRequest, setOnlineViewerActiveApiRequest] = useState<boolean | undefined>(undefined);
    const [onlineViewerIntervalIds, setOnlineViewerIntervalIds] = useState<any[]>([]);
    const [onlineViewerIntervalTime, setOnlineViewerIntervalTime] = useState<number>(0);

    /// GET_DATA interval
    const [getDataActiveApiRequest, setGetDataActiveApiRequest] = useState<boolean | undefined>(undefined);
    const [getDataIntervalIds, setGetDataIntervalIds] = useState<any[]>([]);
    const [getDataRetryCount, setGetDataRetryCount] = useState<number>(RetryCountGeneralDataFetch);
    const [getDataIntervalTime, setGetDataIntervalTime] = useState<number>(0);

    /// POST_DATA interval
    const [postDataActiveApiRequest, setPostDataActiveApiRequest] = useState<boolean | undefined>(undefined);
    const [postDataIntervalIds, setPostDataIntervalIds] = useState<any[]>([]);
    const [postDataIntervalTime, setPostDataIntervalTime] = useState<number>(0);

    useEffect(() => {
        if (postDataActiveApiRequest !== undefined) manualPostAPI();
    }, [postDataActiveApiRequest]);

    useEffect(() => {
        if (onlineViewerActiveApiRequest !== undefined) manualGetOnlineViewerIntervalAPI();
    }, [onlineViewerActiveApiRequest]);

    useEffect(() => {
        if (getDataActiveApiRequest !== undefined)
            manualGetDataIntervalAPI(
                getDataRetryCount,
                getDataIntervalIds,
                getDataIntervalTime,
                setGetDataRetryCount,
                dispatch,
                setGetDataIntervalIds,
                setGetDataIntervalTime,
                setOnlineViewerIntervalTime,
                setPostDataIntervalTime
            );
    }, [getDataActiveApiRequest]);

    useEffect(() => {
        clearIntervalIdsHandler(postDataIntervalIds, setPostDataIntervalIds);
        if (postDataIntervalTime !== 0)
            getGeneralData(postDataIntervalIds, postDataIntervalTime, setPostDataActiveApiRequest, setPostDataIntervalIds);
    }, [postDataIntervalTime]);

    useEffect(() => {
        clearIntervalIdsHandler(onlineViewerIntervalIds, setOnlineViewerIntervalIds);
        if (onlineViewerIntervalTime !== 0)
            getGeneralData(onlineViewerIntervalIds, onlineViewerIntervalTime, setOnlineViewerActiveApiRequest, setOnlineViewerIntervalIds);
    }, [onlineViewerIntervalTime]);

    useEffect(() => {
        clearIntervalIdsHandler(getDataIntervalIds, setGetDataIntervalIds);
        if (getDataIntervalTime !== 0 && !(getDataRetryCount === 1 && getDataIntervalTime === RetryTimeDelayGeneralDataFetch))
            getGeneralData(getDataIntervalIds, getDataIntervalTime, setGetDataActiveApiRequest, setGetDataIntervalIds);
    }, [getDataIntervalTime]);

    const clearIntervalIdsHandler = (ids: any, setIds: any) => {
        ids.forEach((id: any) => clearInterval(id));
        setIds([]);
    };

    useEffect(() => {
        if (conditions(ConditionName.firstGetDataIntervalAPI) && conditions(ConditionName.hasPermittedLoadedFragment)) {
            if (!conditions(ConditionName.isLiveError))
                firstGetDataIntervalAPI(
                    getDataRetryCount,
                    setGetDataRetryCount,
                    dispatch,
                    setGetDataIntervalTime,
                    setOnlineViewerIntervalTime,
                    setPostDataIntervalTime
                );
            else clearIntervalIdsHandler(getDataIntervalIds, setGetDataIntervalIds);
        }
    }, [isLiveError, loadedFragmentsCount.length]);
};

export default useGetAggregat;
